import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { isLoadingAction } from "../../../Utils/helper";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import { useLocation } from "react-router-dom";


export const SendToQcBulkUpload = ({ setBulkSendToQC }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [file, setFile] = useState(null);

  const handleChange = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    downloadFile(formData);
    setFile(file);
    setErrorMessage(null);
  };

  const downloadFile = (formData) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutSendToQCBulkUpload`;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: formData,
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "sendToQcBulkUpload.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        isLoadingAction(false, dispatch);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        isLoadingAction(false, dispatch);
      });
  };

  const handleClose = () => {
    setBulkSendToQC(false);
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Import Your Data Through File</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <div className="modal-body addusermodalbox uploadExcelTest">
        <FileUploader
          handleChange={handleChange}
          name="file"
          onTypeError={(err) => {
            setErrorMessage(err);
            setFile(null);
          }}
          types={["CSV", "XLS", "XLSX"]}
          children={
            <label
              className="sc-beqWaB ewqTBN"
              htmlFor="file"
              style={{
                backgroundColor:
                  errorMessage === null && file === null
                    ? "#F6F6F6"
                    : file !== null
                    ? "rgba(0, 202, 20, 0.1)"
                    : errorMessage !== null && "#FFBABA",
                height: file !== null ? "280px" : "250px",
              }}
            >
              <input accept=".xlsx, .xls, .csv" type="file" name="file" />
              <div className="sc-dmqHEX kyUZVo">
                {file !== null && (
                  <div className="successfull-box">
                    <img src="./../images/csvIcon.svg" />
                    <h5 className="csv-file-text">
                      Successfully Uploaded File
                    </h5>
                    <p className="successfully-file-upload">
                      Your file has been uploaded successfully.
                      <br />
                      Our team will contact you shortly.
                    </p>
                    <p className="margin-right approx-time-text upload-text">
                      Click <a style={{ color: "#5252A3" }}>here</a> to upload
                      another file
                    </p>
                  </div>
                )}
                {errorMessage !== null && (
                  <div className="error-box">
                    <img src="./../images/csvIcon.svg" />
                    <h6 className="csv-file-text">
                      File type is not supported
                    </h6>
                    <p className="margin-right approx-time-text">
                      Click <a>here</a> to upload another file
                    </p>
                  </div>
                )}
                {errorMessage === null && file === null && (
                  <>
                    <img src="./../images/csvIcon.svg" />
                    <h6 className="csv-file-text">Upload CSV OR XLSX File</h6>
                    <span className="approx-time-text">
                      Approximate time to upload 2MB File is 30 seconds
                    </span>
                  </>
                )}
              </div>
            </label>
          }
        />
      </div>
      <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
        <div>
          <p
            className="margin-right approx-time-text"
            style={{ marginLeft: "10px", fontWeight: "600" }}
          >
            Click
            <a
              style={{ color: "#5252A3", cursor: "pointer" }}
              href={`${API_URL_WITHOUT_USER}/FileManager/DownloadFile?path=Provider%20SKUPackageFile/Payout%20Bulk%20SendToQC.xlsx`}
              download
            >
              {" "}
              here{" "}
            </a>
            to download Sample CSV
          </p>
          <p
            className="margin-right approx-time-text"
            style={{ marginLeft: "10px", fontWeight: "600", color: "#5252A3" }}
          >
            <span>Note :</span> Only one type of business can be updated at a
            time
          </p>
        </div>
      </div>
    </>
  );
};
